import * as types from './types';

export const fetchingOrdersRequest = () => ({type: types.FETCHING_ORDER_REQUEST});
export const fetchingOrdersSuccess = data => ({type: types.FETCHING_ORDER_SUCCESS, payload: data});
export const fetchingOrdersFailure = error => ({type: types.FETCHING_ORDER_FAILURE, payload: error});